const Donors = () => {
    const styles = {
        contentAlt: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "block",
            height: "100%",
            width: "100%",
            color: "#FFF",
            padding: "100px 0px",
        },
        donorAlt: {
            borderRadius: "8px",
            backgroundColor: "white",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            width: "60%",
            margin: "20px auto",
            padding: "20px",
            display: "block",
            height: "100%",
            color: "#FFF",
            fontSize: "20px",
            fontWeight: "300",
            fontFamily: "'Raleway', Arial, sans-serif",
            verticalAlign: "middle",
            textAlign: "center" as "center",
        },
        sectionTitleAlt: {
            color: "#000",
            fontSize: "32px",
            paddingBottom: "20px",
            margin: "0px",
            fontWeight: "normal",
        },
        fancy: {
            border: "0px",
            height: "1px",
            width: "60%",
            backgroundImage: "linear-gradient(to right, rgba(0, 0, 0, 0), rgba(255, 255, 255, 1), rgba(0, 0, 0, 0))",
            marginBottom: "30px",
        }
    }
    return (
        <div id="donors">
            <div className="contentAlt" style={styles.contentAlt}>
                <div className="donorAlt" style={styles.donorAlt}>
                    <br />
                    <h3 style={styles.sectionTitleAlt}>Donors</h3>
                    <br />
                    <br />
                    <a href="https://missouri.edu/" className="donor-link">
                        <img
                            src= "/images/donors/mizzou.png"
                            alt="Mizzou"
                            className="donorImg"
                            style={{ maxWidth: "clamp(150px, 25vw, 260px)", height: "auto", verticalAlign: "middle", margin: "10px" }}
                        />
                    </a>
                    <a href="https://engineering.missouri.edu/" className="donor-link">
                        <img
                            src= "/images/donors/mizzou_engineering.png"
                            alt="Mizzou College of Engineering"
                            className="donorImg"
                            style={{ maxWidth: "clamp(150px, 25vw, 260px)", height: "auto", verticalAlign: "middle", margin: "10px" }}
                        />
                    </a>
                    <a href="https://www.solidworks.com/" className="donor-link">
                        <img
                            src= "/images/donors/solidworks.png"
                            alt="SolidWorks"
                            className="donorImg"
                            style={{ maxWidth: "clamp(150px, 25vw, 260px)", height: "auto", verticalAlign: "middle", margin: "10px" }}
                        />
                    </a>
                    <a href="https://www.mathworks.com/" className="donor-link">
                        <img
                            src= "/images/donors/mathworks.png"
                            alt="MathWorks"
                            className="donorImg"
                            style={{ maxWidth: "clamp(150px, 25vw, 260px)", height: "auto", verticalAlign: "middle", margin: "10px" }}
                        />
                    </a>
                    <a href="https://bluerobotics.com/" className="donor-link">
                        <img
                            src= "/images/donors/bluerobotics.png"
                            alt="Blue Robotics"
                            className="donorImg"
                            style={{ maxWidth: "clamp(150px, 25vw, 260px)", height: "auto", verticalAlign: "middle", margin: "10px" }}
                        />
                    </a>
                    <a href="https://www.nvidia.com/en-us/" className="donor-link">
                        <img
                            src= "/images/donors/nvidiaBlackAndWhite.png"
                            alt="NVIDIA"
                            className="donorImg"
                            style={{ maxWidth: "clamp(150px, 25vw, 260px)", height: "auto", verticalAlign: "middle", margin: "10px" }}
                        />
                    </a>
                    <a href="https://www.garmin.com/en-US/" className="donor-link">
                        <img 
                            src="/images/donors/garmin-logo.png"
                            alt="Garmin"
                            className="donorImg"
                            style={{ maxWidth: "clamp(150px, 25vw, 260px)", height: "auto", verticalAlign: "middle", margin: "10px" }}
                        />
                    </a>
                    <a href="https://www.veteransunited.com/" className="donor-link">
                        <img 
                            src="/images/donors/veteransunited.png"
                            alt="Veterans United Home Loans"
                            className="donorImg"
                            style={{ maxWidth: "clamp(150px, 25vw, 260px)", height: "auto", verticalAlign: "middle", margin: "10px" }}
                        />
                    </a>
                    <p style={{ color: "black" }}>Want to help support our team? Contact us below to donate or find more ways to help!</p>
                </div>
            </div>
        </div>
    )
}

export default Donors
